import { CheckboxOptionType } from "antd";
import { TFunction } from "i18next";
import environmentConfig from "../../environmentConfig";
import { Language, translations } from "../../translations";

const { environment } = environmentConfig;

export function getColorSchemeOptions(t: TFunction<"translation">): CheckboxOptionType[] {
  return [
    { value: "", label: t("terms.auto").capitalize() },
    { value: "light", label: t("terms.light").capitalize() },
    { value: "dark", label: t("terms.dark").capitalize() },
  ];
}

export function getWeekDayOptions(t: TFunction<"translation">): CheckboxOptionType[] {
  return [
    { value: 1, label: t("dateTime.monday").capitalize() },
    { value: 2, label: t("dateTime.tuesday").capitalize() },
    { value: 3, label: t("dateTime.wednesday").capitalize() },
    { value: 4, label: t("dateTime.thursday").capitalize() },
    { value: 5, label: t("dateTime.friday").capitalize() },
    { value: 6, label: t("dateTime.saturday").capitalize() },
    { value: 0, label: t("dateTime.sunday").capitalize() },
  ];
}

export function getDateOptions(t: TFunction<"translation">): CheckboxOptionType[] {
  return [
    { value: "", label: t("terms.default").capitalize() },
    { value: "iso", label: "2000-12-31" },
    { value: "eu", label: "31/12/2000" },
    { value: "us", label: "12/31/2000" },
    { value: "written", label: "Dec 31, 2000" },
  ];
}

export function getTimeOptions(t: TFunction<"translation">): CheckboxOptionType[] {
  return [
    { value: "", label: t("terms.default").capitalize() },
    { value: "24hour", label: "17:35" },
    { value: "24hour+sec", label: "17:35:59" },
    { value: "12hour", label: `5:35 ${t("dateTime.pm")}` },
    { value: "12hour+sec", label: `5:35:59 ${t("dateTime.pm")}` },
  ];
}

export function getTimeSpanOptions(t: TFunction<"translation">): CheckboxOptionType[] {
  return [
    { value: "normal", label: "1:23:45" },
    { value: "written", label: `1${t("dateTime.hourShorthand")} 23${t("dateTime.minuteShorthand")} 45${t("dateTime.secondShorthand")}` },
  ];
}

export function getShowDebugInfoOptions(t: TFunction<"translation">): CheckboxOptionType[] {
  return [
    { value: true, label: t("verbs.show").capitalize() },
    { value: false, label: t("verbs.hide").capitalize() },
  ];
}

export function translationToOption(key: string, lang: Language): CheckboxOptionType {
  const { translation: { meta: { languageInEnglish, languageInNative } } } = lang;

  return {
    value: key,
    label: languageInEnglish === languageInNative ? languageInEnglish : `${languageInEnglish} (${languageInNative})`,
  };
}

export const translationOverrideLang = "OVERRIDE";

export function getLanguageOptions(): CheckboxOptionType[] {
  const options: CheckboxOptionType[] = [];

  if (environment !== "prod") {
    options.push({
      value: translationOverrideLang,
      label: "[ Custom translation ]",
    });
  }

  options.push(translationToOption("en-US", translations["en-US"]));

  return options.concat(
    Object.entries(translations)
      .filter(([key]) => key !== "en-US")
      .map(([key, lang]) => translationToOption(key, lang))
      .sortBy(o => o.label as string),
  );
}
